<template>
    <div class="content">
        <HelloWorld :loginFlag="loginFlag" :userName="userName"></HelloWorld>
        <!-- 购买字样 -->
        <div class="bg-image" style="height: 500px;">
            <div style="margin: 0px auto; width: 85%; height: 200px; padding-top: 180px;">
                <div style="font-weight: bold;">
                    <h2>
                        XUS商城系统
                    </h2>
                    <div style="font-size: 13px; color: #000000; margin-top: 10px;">
                        前端采用VUE 后端采用JAVA 更快更稳定
                    </div>
                    <div style="font-size: 13px; color: #000000; margin-top: 10px;">
                        全面注重安全性，尽可能避免被攻击的概率
                    </div>
                </div>
                <div @click="goToProducts()" style="margin-top: 20px; background-color: #f78751; width: 80px; text-align: center; padding-top: 10px; padding-bottom: 10px; color: #ffffff; cursor:pointer;">
                    立刻购买
                </div>
            </div>
        </div>
        <!-- 催牛逼没用的介绍 -->
        <div style="text-align: center; width: 90%; margin: 0px auto; margin-top: 30px;">
            <h3>用独具匠心的好产品，配以贴心周到的好服务</h3>
            <div style="font-size: 13px; margin-top: 10px; color: #999999;">XUS商城作为电商的赋能者，为每一个创业\准备创业的人创造低成本高回报的良好体验</div>

            <!-- 轮播图 -->
            <el-carousel :autoplay="false" :interval="4000" type="card" height="300px" style="width: 100%; margin-top: 25px;" @change="changeImage">
                <el-carousel-item v-for="(item, index) in image" :key="index" style="height: 300px;">
                    <el-image mode="heightFix" :style="item.sty" :src="item.tp"></el-image>
                </el-carousel-item>
            </el-carousel>
        </div>
        <!-- 催牛逼没用的介绍 -->
        <div style="width: 100%; margin: 0px auto; background-color: rgba(250, 173, 137, 0.2); padding-top: 5px; padding-bottom: 5px;">
            <div style="width: 90%; margin: 0px auto; margin-top: 30px;">
                <h3 style="text-align: center;">用独具匠心的好产品，配以贴心周到的好服务</h3>
                <div style="font-size: 13px; margin-top: 10px; color: #999999; text-align: center;">XUS商城作为电商的赋能者，为每一个创业\准备创业的人创造低成本高回报的良好体验</div>

                <!-- 轮播图 -->
                <el-carousel v-if="statusPC == '1'" :autoplay="false" :interval="4000" type="card" height="240px" style="width: 100%; margin-top: 25px;" @change="changeImageTow">
                    <el-carousel-item v-for="(item, index) in textLBG" :key="index" style="height: 240px;">
                        <div class="bg-imageT" style="height: 240px; width: 340px; margin: 0px auto;">
                            <div style=" background-color: rgba(0, 0, 0, 0.4); width: 340; height: 240px; color: #ffffff;">
                                <h2 style="text-align: center; padding-top: 10px;"> {{ index + 1 }}</h2>
                                <div style="width: 95%; margin: 0px auto; margin-top: 10px;">
                                    <h3> {{ item.biaot }}</h3>
                                    <div style="margin-top: 10px; font-size: 14px;">
                                        <p>{{ item.text }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>

        <!-- 底部 -->
        <div style="background-color: #000000; margin-top: 20px; color: #ffffff;">
            <div style="padding-top: 20px; margin-left: 20px; width: 80%; margin: 0px auto;">
                <h3>联系我们</h3>
                <div style="margin-top: 10px;">
                    官方微信：l13514269986、qwdjpk
                </div>
                <div style="margin-top: 10px;">
                    官方qq：2950164010
                </div>
                <div style="margin-top: 10px;">
                    官方电话：13514269986
                </div>
            </div>
            <div style="border: 1px solid #5d5d5d; width: 80%; margin: 0px auto; margin-top: 10px; margin-bottom: 10px;"></div>
            <div style="text-align: center; padding-bottom: 10px;">
                旭杉（沈阳市）网络科技有限公司<br />
                <a href="https://beian.miit.gov.cn" style="color: #ffffff">辽ICP备2023013240号</a><br />
                <a href="https://beian.miit.gov.cn" style="color: #ffffff"> 增值电信业务经营许可证: 辽B2-20240456号 </a>
            </div>
        </div>
    </div>
</template>

<script>
    import HelloWorld from '@/components/top-bar.vue'
    export default {
        components: {
            HelloWorld
        },
        data() {
            return {
                statusPC: sessionStorage.getItem('statusPC'),
                // 用户是否登录
                loginFlag: '',
                // 用户名字
                userName: '',
                // 轮播图
                image: [{
                        tp: require('/src/assets/images/index/lbt2.png'),
                        sty: { 'border': '1px solid #c7c7c7', 'height': '300px', 'border-radius': '20px' }
                    },
                    {
                        tp: require('/src/assets/images/index/lbt3.png'),
                        sty: { 'border': '1px solid #c7c7c7', 'height': '300px', 'border-radius': '20px', 'filter': 'blur(1.3px)', 'filter': 'contrast(15%)' }
                    },
                    {
                        tp: require('/src/assets/images/index/lbt4.png'),
                        sty: { 'border': '1px solid #c7c7c7', 'height': '300px', 'border-radius': '20px', 'filter': 'blur(1.3px)', 'filter': 'contrast(15%)' }
                    },
                    {
                        tp: require('/src/assets/images/index/lbt5.png'),
                        sty: { 'border': '1px solid #c7c7c7', 'height': '300px', 'border-radius': '20px', 'filter': 'blur(1.3px)', 'filter': 'contrast(15%)' }
                    },
                    {
                        tp: require('/src/assets/images/index/lbt6.png'),
                        sty: { 'border': '1px solid #c7c7c7', 'height': '300px', 'border-radius': '20px', 'filter': 'blur(1.3px)', 'filter': 'contrast(15%)' }
                    }
                ],
                // 文字轮播图
                textLBG: [{
                        biaot: '一键安装',
                        text: '像安装软件一样简单的一键式部署，无需会技术最快三分钟即可开始运营商城网站'
                    },
                    {
                        biaot: '门槛极低',
                        text: '服务器门槛和使用门槛都极低，服务器最低可支持1*1服务器，使用方法在管理端中有操作文档，降低服务器开销，帮助客户低成本高回报'
                    },
                    {
                        biaot: '官方维护',
                        text: '如果服务器出现问题，可以找到客服进行上报，我们将第一时间对您的服务器进行维护，避免给您造成不必要的损失'
                    },
                    {
                        biaot: '及时响应',
                        text: '用户发现问题后可来官网或找到客服提交bug或者优化方案，我们将第一时间进行采纳，三个月内会将用户的优化方案更新到所有用户的手中'
                    },
                    {
                        biaot: '定制开发',
                        text: '行业深耕,团队可靠,多年技术沉淀，欢迎用户前来定制开发，旭杉可开发APP、微信小程序、WEB网站，价格低廉'
                    },
                    {
                        biaot: '智能AI客服',
                        text: 'XUS商城全面接入DeepSeek，让客户解决双手，彻底的脱机式管理，让用户们能够坐在家里数钱'
                    }
                ]
            }
        },
        mounted() {
            this.loginFlag = !localStorage.getItem('userTK') == ''
            this.userName = localStorage.getItem('userName')
        },
        methods: {
            changeImage(e) {
                switch (e) {
                    case 0:
                        this.image[0].sty = { 'border': '1px solid #c7c7c7', 'height': '300px', 'border-radius': '20px' }
                        this.image[1].sty = { 'border': '1px solid #c7c7c7', 'height': '300px', 'border-radius': '20px', 'filter': 'contrast(15%)' }
                        this.image[2].sty = { 'border': '1px solid #c7c7c7', 'height': '300px', 'border-radius': '20px', 'filter': 'contrast(15%)' }
                        this.image[3].sty = { 'border': '1px solid #c7c7c7', 'height': '300px', 'border-radius': '20px', 'filter': 'contrast(15%)' }
                        this.image[4].sty = { 'border': '1px solid #c7c7c7', 'height': '300px', 'border-radius': '20px', 'filter': 'contrast(15%)' }
                        break;
                    case 1:
                        this.image[0].sty = { 'border': '1px solid #c7c7c7', 'height': '300px', 'border-radius': '20px', 'filter': 'contrast(15%)' }
                        this.image[1].sty = { 'border': '1px solid #c7c7c7', 'height': '300px', 'border-radius': '20px', 'filter': 'blur(1.3px)' }
                        this.image[2].sty = { 'border': '1px solid #c7c7c7', 'height': '300px', 'border-radius': '20px', 'filter': 'contrast(15%)' }
                        this.image[3].sty = { 'border': '1px solid #c7c7c7', 'height': '300px', 'border-radius': '20px', 'filter': 'contrast(15%)' }
                        this.image[4].sty = { 'border': '1px solid #c7c7c7', 'height': '300px', 'border-radius': '20px', 'filter': 'contrast(15%)' }
                        break;
                    case 2:
                        this.image[0].sty = { 'border': '1px solid #c7c7c7', 'height': '300px', 'border-radius': '20px', 'filter': 'contrast(15%)' }
                        this.image[1].sty = { 'border': '1px solid #c7c7c7', 'height': '300px', 'border-radius': '20px', 'filter': 'contrast(15%)' }
                        this.image[2].sty = { 'border': '1px solid #c7c7c7', 'height': '300px', 'border-radius': '20px', 'filter': 'blur(1.3px)' }
                        this.image[3].sty = { 'border': '1px solid #c7c7c7', 'height': '300px', 'border-radius': '20px', 'filter': 'contrast(15%)' }
                        this.image[4].sty = { 'border': '1px solid #c7c7c7', 'height': '300px', 'border-radius': '20px', 'filter': 'contrast(15%)' }
                        break;
                    case 3:
                        this.image[0].sty = { 'border': '1px solid #c7c7c7', 'height': '300px', 'border-radius': '20px', 'filter': 'contrast(15%)' }
                        this.image[1].sty = { 'border': '1px solid #c7c7c7', 'height': '300px', 'border-radius': '20px', 'filter': 'contrast(15%)' }
                        this.image[2].sty = { 'border': '1px solid #c7c7c7', 'height': '300px', 'border-radius': '20px', 'filter': 'contrast(15%)' }
                        this.image[3].sty = { 'border': '1px solid #c7c7c7', 'height': '300px', 'border-radius': '20px', 'filter': 'blur(1.3px)' }
                        this.image[4].sty = { 'border': '1px solid #c7c7c7', 'height': '300px', 'border-radius': '20px', 'filter': 'contrast(15%)' }
                        break;
                    case 4:
                        this.image[0].sty = { 'border': '1px solid #c7c7c7', 'height': '300px', 'border-radius': '20px', 'filter': 'contrast(15%)' }
                        this.image[1].sty = { 'border': '1px solid #c7c7c7', 'height': '300px', 'border-radius': '20px', 'filter': 'contrast(15%)' }
                        this.image[2].sty = { 'border': '1px solid #c7c7c7', 'height': '300px', 'border-radius': '20px', 'filter': 'contrast(15%)' }
                        this.image[3].sty = { 'border': '1px solid #c7c7c7', 'height': '300px', 'border-radius': '20px', 'filter': 'contrast(15%)' }
                        this.image[4].sty = { 'border': '1px solid #c7c7c7', 'height': '300px', 'border-radius': '20px', 'filter': 'blur(1.3px)' }
                        break;
                }
            },
            changeImageTow(e) {

            },
            goToProducts() {
                this.$router.push('/products');
            }

        }
    }
</script>

<style scoped>
    .bg-image {
        background-image: url('/src/assets/images/xus4.png');
        background-size: cover;
        background-repeat: no-repeat;
    }

    .bg-imageT {
        background-image: url('/src/assets/images/index/lunbT.png');
        background-size: cover;
        background-repeat: no-repeat;
    }

    /* 立即注册按钮 */
    .logindiv {
        background-color: #0055ff;
        height: 35px;
        line-height: 35px;
        margin-top: 12px;
        border-radius: 20px;
        padding-left: 10px;
        padding-right: 10px;
        color: #ffffff;
    }


    .container {
        width: 95%;
        height: 60px;
    }

    .fixed-top {
        position: fixed;
        top: 0;
        width: 100%;
        background-color: #ffffff;
        z-index: 999;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }
</style>